// extracted by mini-css-extract-plugin
var _1 = "FileAttachedItemsModalTableRow-moduleFileAttachedItemsModalTableRow__pCQKZ TableComponent-modulerow__xPAo4";
var _2 = "FileAttachedItemsModalTableRow-modulefileIcon__ZSqNr FileIconPreview-moduleicon__wDz2Z FileIconPlaceholder-modulefileIconPlaceholder__ZGAvo FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
export { _1 as "FileAttachedItemsModalTableRow", _2 as "fileIcon" }
